import service from '@/service'
/**
 * @description 单据列表查询
 */
export function orderList(params) {
  return service['api-web']({
    url: '/dc/wms/getDockOrderList',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @description 对接处理结果查询
 */
export function getList(params) {
  return service['api-web']({
    url: '/dc/wms/getDockResultList',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @description 查看结果
 */
export function viewResult(params) {
  return service['api-web']({
    url: '/dc/wms/getResult',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @description 手动对接
 */
export function manualDock(data) {
  return service['api-web']({
    url: '/dc/wms/manualDock',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' }
  })
}

/**
 * @description 结果导出
 */
export function resultExport(params) {
  return service['api-web']({
    url: '/dc/wms/resultExport',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob', // 文件流接收类型声明转成 blob
    saveAs: true // 文件流是否通过浏览器下载
  })
}

/**
 * @description 单据列表导出
 */
export function exportDockOrderList(data) {
  return service['api-web']({
    url: '/dc/wms/exportDockOrderList',
    method: 'post',
    data
    // responseType: 'blob' // 文件流接收类型声明转成 blob
  })
}
